export default "__VITE_ASSET__pj8ZmTlI__"